import React from 'react';
import { Box, Typography, Divider, Link } from '@mui/material';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';

const ReferencesURL: React.FC = () => {
  return (
    <>
      <Typography sx={{ fontSize: 16, color: 'text.secondary', mb: 2 }}>
        Always read the updated My Oracle Support Note and the updated Oracle Documentation about AutoUpgrade and watch the latest videos on Official YouTube Channel for Upgrades and Migrations:
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://docs.oracle.com/en/database/oracle/oracle-database/19/upgrd/using-autoupgrade-oracle-database-upgrades.html" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            Using AutoUpgrade for Oracle Database Upgrades
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://docs.oracle.com/en/database/oracle/oracle-database/19/upgrd/autoupgrade.html" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            AutoUpgrade Patching
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://support.oracle.com/epmos/faces/DocumentDisplay?id=2485457.1" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            AutoUpgrade Tool Reference Note (Doc ID 2485457.1)
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://www.youtube.com/@upgradenow" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            Oracle Database Upgrades and Migrations YouTube Channel
          </Link>
        </Box>
      </Box>
      <Divider sx={{ my: 3 }} />
      <Typography sx={{ fontSize: 16, color: 'text.secondary', mb: 2 }}>
        Also, follow the blog of the Oracle Product Managers from the Database Upgrades and Migrations team:
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://alexzaballa.com/" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            Alex Zaballa
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://dohdatabase.com/" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            Daniel Overby Hansen
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://mikedietrichde.com/" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            Mike Dietrich
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LinkOutlinedIcon sx={{ color: 'primary.main', fontSize: 18 }} />
          <Link href="https://www.dbarj.com.br/" target="_blank" rel="noopener" underline="hover" sx={{ fontSize: 16 }}>
            Rodrigo Jorge
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default ReferencesURL; 